import React from 'react';

import HeaderText from 'components/shared/header-text';
import CodeExample from 'components/code-snippet/CodeSnippet';
import PreviewWindow from './PreviewWindow';
import Collapsible from './Collapsible';

import '../index.scss';

const landingPageTemplate = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <title>Landing Page</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      margin: 0;
      padding: 0;
      text-align: center;
    }
    header {
      background: #4a90e2;
      color: white;
      padding: 60px 20px;
    }
    section {
      padding: 40px 20px;
    }
    button {
      padding: 10px 20px;
      font-size: 16px;
      background: #26e07f;
      border: none;
      color: white;
      cursor: pointer;
    }
  </style>
</head>
<body>
  <header>
    <h1>Welcome to My Website</h1>
    <p>Your go-to place for cool stuff</p>
    <button>Get Started</button>
  </header>
  <section>
    <h2>About Us</h2>
    <p>We build modern websites with style and performance in mind.</p>
  </section>
</body>
</html>
`;

const signInFormTemplate = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <title>Sign In</title>
  <style>
    body {
      min-width: 250px;
      font-family: sans-serif;
      background: #f4f4f4;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      overflow-x: scroll;
      padding: 30px;
    }
    form {
      background: white;
      padding: 30px;
      border-radius: 8px;
      box-shadow: 0 0 10px rgba(0,0,0,0.1);
    }
    input {
      display: block;
      width: 228px;
      margin-bottom: 15px;
      padding: 10px;
      font-size: 16px;
    }
    button {
      width: 250px;
      padding: 10px;
      background: #4a90e2;
      color: white;
      border: none;
      font-size: 16px;
      cursor: pointer;
    }
  </style>
</head>
<body>
  <form>
    <h2>Sign In</h2>
    <input type="email" placeholder="Email" required />
    <input type="password" placeholder="Password" required />
    <button type="submit">Login</button>
  </form>
</body>
</html>
`;

const productCardTemplate = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <title>Product Card</title>
  <style>
    body {
      font-family: sans-serif;
      padding: 40px;
      display: flex;
      justify-content: center;
    }
    .product-card {
      border: 1px solid #ccc;
      border-radius: 10px;
      width: 300px;
      padding: 20px;
      text-align: center;
      box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    }
    .product-card img {
      width: 100%;
      border-radius: 10px;
    }
    .product-card h2 {
      margin: 15px 0 10px;
    }
    .product-card p {
      color: #555;
      font-size: 14px;
    }
    .product-card button {
      background-color: #4CAF50;
      color: white;
      border: none;
      padding: 10px 20px;
      margin-top: 15px;
      cursor: pointer;
    }
  </style>
</head>
<body>
  <div class="product-card">
    <img src="https://via.placeholder.com/300x200" alt="Product Image" />
    <h2>Product Name</h2>
    <p>This is a short description of the product.</p>
    <button>Add to Cart</button>
  </div>
</body>
</html>
`;

const HtmlTemplateTab = () => (
  <div className="tab-view">
    <HeaderText
      fontSize="30px"
      fontWeight="bold"
      margin="0 0 40px 0"
      text="HTML Templates"
    />
    <div className="inner-tab-content">
      <Collapsible title="Landing Page">
        <h2>Preview</h2>
        <PreviewWindow html={landingPageTemplate} />
        <h2>Code</h2>
        <CodeExample codeString={landingPageTemplate} />
      </Collapsible>
      <Collapsible title="Signin Form">
        <h2>Preview</h2>
        <PreviewWindow html={signInFormTemplate} />
        <h2>Code</h2>
        <CodeExample codeString={signInFormTemplate} />
      </Collapsible>
      <Collapsible title="Product Card">
        <h2>Preview</h2>
        <PreviewWindow html={productCardTemplate} />
        <h2>Code</h2>
        <CodeExample codeString={productCardTemplate} />
      </Collapsible>
    </div>
  </div>
);

export default HtmlTemplateTab;
